module.exports = __webpack_public_path__ + "static/img/pic_banner@2x.4be87d79.png";